var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t-watermark-box"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.config.power),expression:"config.power"}],staticClass:"t-watermark",style:([!_vm.config.fullscreen?{
       left:_vm.offset[0] + 'rem',
       top: _vm.offset[1] + 'rem',
  }:null,{position:_vm.fixed}])},[_c('canvas',{ref:"canvas"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }